import { createContext, useContext, useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { STORAGE_KEYS } from "../../config/storageKeys";

const VisitorContext = createContext();
const BASE_URL = process.env.REACT_APP_BASE_URL;

export function VisitorProvider({ children }) {
  const [uniqueVisitors, setUniqueVisitors] = useState(null);
  const [visitorId, setVisitorId] = useState(localStorage.getItem(STORAGE_KEYS.VISITOR_ID));

  useEffect(() => {
    if (!visitorId) {
      const newVisitorId = uuidv4();
      setVisitorId(newVisitorId);
      localStorage.setItem(STORAGE_KEYS.VISITOR_ID, newVisitorId);
    }

    async function trackVisit() {
      try {
        const res = await fetch(BASE_URL + "/track-visit", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ visitorId }),
        });
        const data = await res.json();
        setUniqueVisitors(data.uniqueVisitors);
      } catch (err) {
        console.error("Error tracking visit:", err);
      }
    }

    trackVisit();
  }, []);

  return (
    <VisitorContext.Provider value={{ visitorId, uniqueVisitors }}>
      {children}
    </VisitorContext.Provider>
  );
}

export function useVisitor() {
  return useContext(VisitorContext);
}
